import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { selectors } from 'lib/entities/credentials';
import { FrameType, IImageData } from './types';
import ModalImageSlider from './Modal';
import SingleImage from './SingleImage';
import MultipleImage from './MultipleImage';

interface ImageSliderProps {
  images: Array<IImageData>;
  frameType: FrameType;
  clickable?: boolean;
  mode?: 'post' | 'comment';
  isRepost?: boolean;
  isSinglePost?: boolean;
}

function ImageSlider({
  images = [],
  frameType,
  clickable = true,
  mode = 'post',
  isRepost = false,
  isSinglePost = false,
}: ImageSliderProps) {
  const { isLoggedIn } = useSelector(selectors);
  const router = useRouter();
  const [active, setActive] = useState<number>(0);
  const [showModal, setShowModal] = useState<boolean>(false);

  if (images?.length === 0) return null;

  const imageUrls = images.map((image) => image.image);

  const onClick = () => {
    if (isRepost) {
      return;
    }

    if (isLoggedIn) {
      if (clickable) {
        setShowModal(true);
      }
    } else {
      router.push('/register');
    }
  };

  const onCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      {images.length === 1 ? (
        <SingleImage
          image={images[0]}
          onClick={onClick}
          isLoggedIn={isLoggedIn}
          mode={mode}
        />
      ) : (
        <MultipleImage
          images={images}
          active={active}
          frameType={frameType}
          isSinglePost={isSinglePost}
          onClick={onClick}
          setActive={setActive}
        />
      )}
      <ModalImageSlider
        images={imageUrls}
        visible={showModal}
        onClose={onCloseModal}
        active={active}
        setActive={setActive}
      />
    </>
  );
}

export default ImageSlider;
